import {
    RESET_COACHES,
    GET_ALL_COACHES,
    GET_ALL_COACHES_SUCCESS,
    GET_ALL_COACHES_ERROR
} from '../constants/ActionTypes';

export const resetCoaches = () => {
    return {
        type: RESET_COACHES,
    };
};

export const getAllCoaches = (sessionToken) => {
    return {
        type: GET_ALL_COACHES,
        payload: sessionToken
    };
};

export const getAllCoachesSuccess = (coachResponse) => {
    return {
        type: GET_ALL_COACHES_SUCCESS,
        payload: coachResponse
    };
};

export const getAllcoachesError = (coachResponse) => {
    return {
        type: GET_ALL_COACHES_ERROR,
        payload: coachResponse
    };
};
